export default __webpack_public_path__ + "static/media/description_3.a59d9f61.svg";